import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface ToggleSwitchDriver extends BaseUniDriver {
  click(): Promise<void>;
  isChecked(): Promise<boolean>;
  isDisabled(): Promise<boolean>;
  getId(): Promise<string>;
  getTabIndex(): Promise<string>;
}

export const toggleSwitchDriverFactory = (
  base: UniDriver,
): ToggleSwitchDriver => {
  const getInnerCheckbox = () => base.$('input');
  const getCheckboxProp = (prop: string) => getInnerCheckbox()._prop(prop);

  return {
    ...baseUniDriverFactory(base),
    /** Triggers change */
    click: async () => {
      const checkbox = getInnerCheckbox();
      await checkbox.click();
    },
    /** Returns a boolean indicating if the toggleSwitch is checked */
    isChecked: async () => {
      return getCheckboxProp('checked');
    },
    /** Returns a boolean indicating if the toggleSwitch is disabled */
    isDisabled: async () => {
      return getCheckboxProp('disabled');
    },
    /** Returns the id of the input */
    getId: async () => {
      return getCheckboxProp('id');
    },
    /** Returns the tab index */
    getTabIndex: async () => {
      return getCheckboxProp('tabIndex');
    },
  };
};
